module.exports = __webpack_public_path__ + "img/loxone_logo.5edc74ac.svg";